var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 443,
    height: 112,
    viewBox: "0 0 443 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367.972 -10.7494L375.656 1.54731C376.241 2.48441 377.475 2.76913 378.412 2.18357L388.588 -4.17546C389.525 -4.76102 389.81 -5.9943 389.225 -6.93139L383.395 -16.2599C382.81 -17.197 381.577 -17.4817 380.639 -16.8962L370.039 -10.2722C369.337 -9.83342 368.411 -10.0472 367.972 -10.7494V-10.7494C367.533 -11.4516 367.747 -12.3776 368.449 -12.8163L379.05 -19.4403",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.736 13.8387L325.941 12.5666",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M326.643 20.2724L326.615 19.8416C326.591 19.4737 326.771 19.1228 327.083 18.9278L331.158 16.3815C331.47 16.1865 331.864 16.1787 332.184 16.3607L332.559 16.5744C332.963 16.8055 333.155 17.2845 333.021 17.7303L332.023 21.053C331.879 21.5335 331.4 21.8329 330.904 21.7525L327.48 21.1928C327.021 21.1188 326.674 20.7367 326.643 20.2724V20.2724Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.149 12.7793L333.467 11.4013",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.972 19.1383L321.594 18.8202",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.815 21.4117C327.603 23.3149 327.66 25.9029 329.359 27.7813C330.757 29.3262 333.026 29.8987 334.981 29.1803C338.239 27.9845 339.411 24.2188 337.678 21.4449C336.57 19.6716 334.578 18.8059 332.63 19.0268",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M285.645 51.8962C286.363 51.4479 287.239 51.7787 287.607 52.3672C288.353 53.5613 286.965 55.7881 286.929 55.8109C286.892 55.8337 284.283 56.1049 283.536 54.9108C283.169 54.3223 283.256 53.3895 283.973 52.9412C284.383 52.6847 284.773 52.7078 285.036 52.7816C285.085 52.5128 285.235 52.1527 285.645 51.8962Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.749 50.7226L285.037 52.7833",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.517 58.3525C284.135 61.0906 278.453 60.0197 275.343 56.0353C275.005 55.6017 275.07 54.9773 275.497 54.6326C278.075 52.5491 278.784 49.0886 276.884 45.4634C276.646 45.0085 276.816 44.4447 277.252 44.1746L278.985 43.0986L280.712 42.0117C281.147 41.7376 281.728 41.8327 282.032 42.2468C284.457 45.5434 287.878 46.4223 290.88 45.0204C291.379 44.7878 291.969 45.0025 292.21 45.498C294.428 50.039 292.898 55.6149 288.517 58.3525Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.64 45.5001C286.52 47.6437 285.546 49.6002 283.749 50.7226",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.788 51.0314C279.768 51.8629 281.953 51.8449 283.749 50.7226",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M238.384 80.7349C239.566 79.9962 241.009 80.5413 241.615 81.5106C242.844 83.4772 240.558 87.1448 240.498 87.1824C240.438 87.2201 236.139 87.6668 234.91 85.6993C234.304 84.73 234.447 83.194 235.629 82.4552C236.305 82.0329 236.947 82.0715 237.379 82.1917C237.461 81.7504 237.707 81.1578 238.384 80.7349V80.7349Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.446 79.0783C235.47 79.0634 235.5 79.0704 235.515 79.0942C235.53 79.1179 235.523 79.1483 235.499 79.1631C235.475 79.1779 235.445 79.1709 235.43 79.1472C235.415 79.1234 235.422 79.0931 235.446 79.0783",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.716 77.0698C237.74 77.055 237.771 77.062 237.785 77.0857C237.8 77.1095 237.793 77.1398 237.769 77.1546C237.746 77.1694 237.715 77.1624 237.701 77.1387C237.686 77.115 237.693 77.0846 237.716 77.0698",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.042 74.4729C239.065 74.4581 239.096 74.4651 239.111 74.4888C239.125 74.5126 239.118 74.5429 239.095 74.5577C239.071 74.5726 239.041 74.5656 239.026 74.5418C239.011 74.5181 239.018 74.4878 239.042 74.4729",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.678 71.717C239.702 71.7022 239.732 71.7092 239.747 71.7329C239.762 71.7567 239.755 71.787 239.731 71.8018C239.707 71.8166 239.677 71.8096 239.662 71.7859C239.647 71.7622 239.654 71.7318 239.678 71.717",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.628 68.8062C239.652 68.7914 239.682 68.7984 239.697 68.8221C239.712 68.8459 239.705 68.8762 239.681 68.891C239.657 68.9059 239.627 68.8989 239.612 68.8751C239.597 68.8514 239.604 68.8211 239.628 68.8062",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.644 80.2393C232.621 80.2541 232.614 80.2844 232.628 80.3082C232.643 80.3319 232.674 80.3389 232.697 80.3241C232.721 80.3092 232.728 80.2789 232.713 80.2552C232.699 80.2309 232.668 80.2244 232.644 80.2393",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.729 80.292C229.706 80.3068 229.699 80.3371 229.713 80.3609C229.728 80.3846 229.759 80.3916 229.782 80.3768C229.806 80.3619 229.813 80.3316 229.798 80.3079C229.784 80.2836 229.753 80.2771 229.729 80.292",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.973 79.6557C226.95 79.6706 226.943 79.7009 226.957 79.7246C226.972 79.7484 227.003 79.7554 227.026 79.7405C227.05 79.7257 227.057 79.6954 227.042 79.6716C227.028 79.6473 226.997 79.6409 226.973 79.6557",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.379 78.3347C224.355 78.3496 224.348 78.3799 224.363 78.4036C224.378 78.4274 224.408 78.4344 224.432 78.4195C224.456 78.4047 224.463 78.3744 224.448 78.3506C224.434 78.3263 224.403 78.3199 224.379 78.3347",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M190.147 100.958L197.566 112.83C198.151 113.767 197.867 115.001 196.929 115.586L190.145 119.826C189.208 120.411 187.975 120.126 187.389 119.189L179.97 107.317C179.385 106.38 179.669 105.146 180.606 104.561L187.391 100.321C188.328 99.7359 189.561 100.021 190.147 100.958Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.414 117.44L196.506 111.134",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.693 106.028C188.59 105.468 189.686 105.881 190.145 106.616C191.078 108.11 189.344 110.893 189.298 110.922C189.252 110.95 185.99 111.289 185.057 109.796C184.597 109.061 184.706 107.895 185.603 107.334C186.117 107.014 186.603 107.043 186.932 107.135C186.993 106.799 187.18 106.349 187.693 106.028Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260.293 -3.79912C258.732 -6.29663 255.379 -7.0171 252.803 -5.40721C250.226 -3.79731 249.404 -0.467514 250.964 2.02999C251.612 3.06545 252.895 3.4299 253.832 2.84433C254.769 2.25877 255.003 0.944929 254.357 -0.08969C252.796 -2.58719 249.443 -3.30767 246.866 -1.69777C244.29 -0.0878796 243.468 3.24192 245.028 5.73942C248.229 10.8616 256.805 10.9585 258.313 10.0163C259.821 9.07408 263.494 1.32309 260.293 -3.79912Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.846 40.4561L206.03 41.5911C205.093 42.1767 203.859 41.892 203.274 40.9549L202.578 39.8406C202.297 39.3911 201.848 39.0712 201.331 38.9519L200.051 38.6564C198.975 38.4079 198.304 37.3343 198.553 36.2581L198.848 34.978C198.967 34.4613 198.877 33.9178 198.596 33.4683L197.899 32.354C197.314 31.4169 197.599 30.1836 198.536 29.598L199.65 28.9017C200.099 28.6209 200.419 28.1722 200.539 27.6555L200.834 26.3753C201.083 25.2991 202.156 24.6283 203.232 24.8767L204.513 25.1723C205.029 25.2916 205.573 25.2008 206.022 24.9199L207.137 24.2236C208.074 23.638 209.307 23.9228 209.893 24.8599L210.589 25.9742C210.87 26.4237 211.318 26.7435 211.835 26.8628L213.115 27.1583C214.191 27.4068 214.862 28.4804 214.614 29.5566L214.318 30.8368C214.199 31.3535 214.29 31.897 214.571 32.3464L215.267 33.4608C215.853 34.3979 215.568 35.6311 214.631 36.2167L213.516 36.913C213.067 37.1939 212.747 37.6425 212.628 38.1593L212.332 39.4394C212.084 40.5156 211.01 41.1865 209.934 40.938L207.846 40.4561Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.371 29.468C207.568 28.7203 209.067 29.3341 209.716 30.3722C211.033 32.4796 208.779 36.2874 208.719 36.325C208.659 36.3626 204.248 36.7189 202.931 34.6115C202.283 33.5735 202.388 31.957 203.585 31.2093C204.269 30.7816 204.93 30.8392 205.378 30.9789C205.449 30.5149 205.687 29.8956 206.371 29.468V29.468Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.76 57.2495C155.917 56.2008 156.448 54.8017 157.988 53.8399C160.68 52.1574 164.065 53.5564 165.535 55.9097C168.609 60.8292 164.84 68.425 163.332 69.3672C161.824 70.3094 153.344 70.3678 150.27 65.4483C148.8 63.0949 149.026 59.4395 151.719 57.757C153.258 56.7952 154.748 56.9311 155.76 57.2495Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.152 64.2789L158.828 62.1588",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.599 60.7921C159.002 60.8852 159.254 61.2879 159.161 61.6915C159.068 62.0951 158.665 62.3468 158.261 62.2536C157.858 62.1604 157.606 61.7577 157.699 61.3541C157.792 60.9505 158.195 60.6989 158.599 60.7921",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.269 86.925C108.426 85.8763 108.958 84.4772 110.497 83.5154C113.189 81.8329 116.574 83.2319 118.045 85.5852C121.119 90.5047 117.349 98.1005 115.841 99.0427C114.333 99.9849 105.854 100.043 102.78 95.1237C101.309 92.7704 101.536 89.115 104.228 87.4325C105.767 86.4707 107.258 86.6065 108.269 86.925Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.4607 111.093C66.8168 110.497 68.2512 111.291 68.7397 112.403C69.732 114.659 66.767 118.166 66.6989 118.197C66.6303 118.226 62.042 118.039 61.0503 115.784C60.5618 114.672 60.9462 113.08 62.3023 112.483C63.0776 112.143 63.7466 112.281 64.1824 112.475C64.3351 112.021 64.6853 111.434 65.4607 111.093V111.093Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.863 11.6991L129.736 4.28021C130.673 3.69465 131.906 3.97938 132.492 4.91647L139.381 15.9411",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.794 24.8443V24.8443C131.731 24.2587 132.016 23.0254 131.43 22.0883L130.9 21.2403",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.452 9.7995C129.169 9.35119 130.046 9.68199 130.413 10.2705C131.159 11.4646 129.772 13.6914 129.735 13.7142",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.779 10.8445C126.062 11.2928 125.975 12.2256 126.343 12.8141C127.089 14.0082 129.699 13.737 129.735 13.7142",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.842 10.685C127.891 10.4162 128.041 10.056 128.452 9.7995",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.842 10.685C127.579 10.6112 127.19 10.588 126.779 10.8445",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.781 17.8481L134.717 14.1387",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.9 21.2403L141.077 14.8813L141.551 15.6403C142.168 16.6265 141.868 17.9246 140.882 18.5409V18.5409L130.794 24.8443C129.857 25.4298 128.624 25.1451 128.038 24.208L121.149 13.1834L120.619 12.3353C120.034 11.3982 118.8 11.1135 117.863 11.6991V11.6991C116.926 12.2846 116.642 13.5179 117.227 14.455L117.757 15.3031",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.757 15.3031L121.149 13.1834",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.4923 44.7668L84.365 37.3479C85.3021 36.7623 86.5354 37.0471 87.121 37.9841L92.9501 47.3127C93.5356 48.2498 93.2509 49.483 92.3138 50.0686L82.1372 56.4276C81.2001 57.0132 79.9669 56.7285 79.3813 55.7914L72.5194 44.81C72.0515 44.0612 72.1302 43.0946 72.7122 42.4314L79.7984 34.3574C80.2401 33.8527 81.0428 33.9183 81.3978 34.4865L83.517 37.8778",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.8593 43.0055C84.1153 42.2207 85.6492 42.7998 86.2925 43.8293C87.5983 45.9189 85.1695 49.8162 85.1058 49.8559C85.0422 49.8957 80.4747 50.3702 79.1689 48.2806C78.5256 47.2511 78.6776 45.6185 79.9335 44.8337C80.6518 44.3849 81.3332 44.4261 81.7928 44.5539C81.8793 44.0848 82.141 43.4543 82.8593 43.0055Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.6712 79.2142L33.7985 86.633C32.8614 87.2186 31.6281 86.9339 31.0425 85.9968L22.5638 72.428C21.9783 71.4909 22.263 70.2576 23.2001 69.6721L35.0728 62.2532C36.0099 61.6676 37.2431 61.9524 37.8287 62.8895L46.3074 76.4582C46.893 77.3953 46.6082 78.6286 45.6712 79.2142Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.4176 74.8676L32.6332 79.1069",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3112 78.4716L35.919 80.5912",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3009 68.702C33.1981 68.1413 34.2936 68.5546 34.7531 69.2899C35.6862 70.7833 33.9515 73.5665 33.9057 73.5951C33.8599 73.6237 30.598 73.9628 29.6648 72.4694C29.2053 71.7341 29.3141 70.5683 30.2113 70.0077C30.7244 69.6871 31.211 69.7167 31.5396 69.8085C31.6011 69.4729 31.7878 69.0226 32.3009 68.702Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-2.25178 106.33C-6.93215 100.17 -12.6989 100.416 -12.6989 100.416C-13.8414 98.5879 -13.2458 96.533 -12.7373 95.3899C-12.5001 94.8561 -12.7106 94.2211 -13.2122 93.9072L-13.7701 93.5578C-14.2286 93.2712 -14.8271 93.3174 -15.1917 93.702C-16.0649 94.6238 -16.604 95.8557 -16.8912 96.6755C-17.064 97.169 -17.5431 97.4684 -18.0632 97.4078C-18.9268 97.3071 -20.2704 97.2517 -21.4808 97.6319C-21.9869 97.7901 -22.2907 98.3078 -22.2336 98.8464L-22.1641 99.501C-22.1019 100.089 -21.6221 100.557 -21.0397 100.578C-19.7893 100.622 -17.6813 100.987 -16.5388 102.816C-16.5388 102.816 -19.2891 107.891 -15.8036 114.798C-14.9891 116.413 -12.697 116.32 -12.1487 114.627L-12.1386 114.596C-11.8013 113.556 -10.6266 112.721 -9.55388 112.947C-8.32621 113.205 -6.98513 112.376 -6.66225 111.166C-6.37499 110.091 -5.10632 109.383 -4.00659 109.539V109.539C-2.24511 109.79 -1.15693 107.77 -2.25178 106.33V106.33Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.2214 1.62397L51.3487 9.04284C50.4116 9.6284 49.1784 9.34368 48.5928 8.40658L47.003 5.86244C46.4175 4.92535 46.7022 3.69207 47.6393 3.10651L59.512 -4.31236C60.4491 -4.89793 61.6823 -4.6132 62.2679 -3.67611L63.8577 -1.13196C64.4432 -0.19487 64.1585 1.03841 63.2214 1.62397Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.9278 -3.32247L49.3337 2.04773C48.3983 2.63223 47.165 2.34751 46.5805 1.41211L44.9886 -1.13543C44.4041 -2.07082 44.6889 -3.3041 45.6243 -3.88861L54.1081 -9.18992C55.0435 -9.77442 56.2768 -9.48969 56.8613 -8.5543L58.5221 -5.89651C59.069 -5.02133 58.803 -3.86935 57.9278 -3.32247V-3.32247Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7978 -2.82806C62.3373 -2.54031 61.9653 -2.11094 61.7907 -1.60916C61.6161 -1.10737 61.2441 -0.678 60.7836 -0.390254C60.3231 -0.102507 59.7741 0.0436147 59.2466 -0.0193987C58.719 -0.0824121 58.17 0.06371 57.7095 0.351456C57.249 0.639202 56.8771 1.06857 56.7024 1.57036C56.5278 2.07215 56.1558 2.50152 55.6953 2.78926C55.2348 3.07701 54.6858 3.22313 54.1583 3.16012C53.6307 3.0971 53.0817 3.24323 52.6212 3.53097C52.1608 3.81872 51.7888 4.24809 51.6141 4.74987C51.4395 5.25166 51.0675 5.68103 50.607 5.96878C50.1465 6.25652 49.5975 6.40265 49.07 6.33963C48.5424 6.27662 47.9934 6.42274 47.533 6.71049",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3923 -7.70455C57.0344 -7.48093 56.765 -7.11568 56.6676 -6.66211C56.571 -6.20908 56.3016 -5.84383 55.9429 -5.61967C55.585 -5.39605 55.1386 -5.31404 54.6882 -5.42528C54.2379 -5.53652 53.7923 -5.45505 53.4336 -5.23089C53.0749 -5.00673 52.8064 -4.64201 52.7089 -4.18845C52.6123 -3.73542 52.3429 -3.37017 51.9842 -3.14601C51.6255 -2.92185 51.1799 -2.84038 50.7296 -2.95162C50.28 -3.06338 49.8336 -2.98138 49.4749 -2.75723C49.1162 -2.53307 48.8494 -2.16941 48.7528 -1.71638C48.6561 -1.26334 48.3868 -0.898092 48.028 -0.673936C47.6702 -0.45031 47.2238 -0.368308 46.7734 -0.479545C46.3239 -0.591311 45.8775 -0.509309 45.5196 -0.285683",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-7.85532 23.4717C-7.19598 24.4099 -5.84533 24.4408 -5.08915 23.5639C-2.25123 20.2741 2.31704 19.1458 6.00448 21.1068C9.69193 23.0677 11.3113 27.4859 10.1707 31.6784C9.86634 32.7954 10.6473 33.8981 11.7937 33.9211",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.79145 18.7451C10.5127 17.3877 9.59195 15.482 9.12727 15.2347C8.66312 14.9882 6.56737 15.2895 5.84613 16.647C5.5726 17.1623 5.75866 17.9186 6.32552 18.22C6.63068 18.3819 6.97868 18.4085 7.27888 18.3058C7.42548 18.2555 7.57408 18.3348 7.61435 18.4842C7.69689 18.7899 7.91523 19.0638 8.22007 19.2271C8.78608 19.529 9.51793 19.2604 9.79145 18.7451V18.7451Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.885489 35.4747L2.96536 31.5643L1.82558 28.9666L-0.954102 29.4548L-3.03344 33.366L-0.253765 32.8778L0.885489 35.4747Z",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48725 18.3148L1.82057 28.9661",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2059 32.7236L2.22723 32.9571",
    stroke: "#5458F7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern);
export default __webpack_public_path__ + "static/media/pattern.c5a230aa.svg";
export { ForwardRef as ReactComponent };